import { PricingOutput } from "../../utils/constants";
import {getPrices, getStockInfo} from "../../api/productController";

export const fetchProductStockInfo = async ({
    productSkus,
    setPricingData,
    setQuantities,
    setStatusInProgress,
    setStatusSuccess,
    setStatusFailed,
    setStatusError
}) => {
    setStatusInProgress();
    try {
        const response = await getStockInfo({
            productSkus,
            output: PricingOutput.Product,
        });

        if (!!response?.success) {
            setPricingData(response.data.prices);
            setQuantities(response.data.quantities);
            setStatusSuccess();
        }
        else {
            setStatusFailed();
        }
    }
    catch (error) {
        console.error(error);
        setStatusError();
    }
};

export const fetchCartPriceData = async ({
	productSkus,
	setPricingData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let response = await getPrices({
			productSkus,
			output: PricingOutput.Cart
		});

		if (!!response?.success) {
			setPricingData(response.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const fetchCartStockInfo = async ({
    productSkus,
    setPricingData,
    setQuantities,
    setStatusInProgress,
    setStatusSuccess,
    setStatusFailed,
    setStatusError
}) => {
    setStatusInProgress();
    try {
        const response = await getStockInfo({
            productSkus,
            output: PricingOutput.Cart,
        });

        if (!!response?.success) {
            setPricingData(response.prices);
            setQuantities(response.quantities);
            setStatusSuccess();
        }
        else {
            setStatusFailed();
        }
    }
    catch (error) {
        console.error(error);
        setStatusError();
    }
};

export const fetchCartSummaryPriceData = async ({
	productSkus,
	setCartSummaryPricingData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let response = await getPrices({
			productSkus,
			output: PricingOutput.CartSummary
		});

		if (!!response?.success) {
			setCartSummaryPricingData(response.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const fetchCartSummaryStockInfo = async ({
    productSkus,
    setPricingData,
    setQuantities,
    setStatusInProgress,
    setStatusSuccess,
    setStatusFailed,
    setStatusError
}) => {
    setStatusInProgress();
    try {
        const response = await getStockInfo({
            productSkus,
            output: PricingOutput.CartSummary,
        });

        if (!!response?.success) {
            setPricingData(response.prices);
            setQuantities(response.quantities);
            setStatusSuccess();
        }
        else {
            setStatusFailed();
        }
    }
    catch (error) {
        console.error(error);
        setStatusError();
    }
};
